import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DashboardLayout from "../Layout/DashboardLayout";
import DashboardTopbar from "../Layout/DashboardTopbar";
import useTokenBalance from "../hooks/useTokenBalance";
import EngineConfigForm from "./EngineConfig/EngineConfigForm";
import {
  getPersistedEngineConfigUiState,
  saveEngineConfigPersistence
} from "../utils/engineConfigPersistence";
import "./EngineConfig/engine-config-modal.css";

const EngineConfig = () => {
  const { id } = useParams();
  const { t } = useTranslation("common");
  const { tokenBalance } = useTokenBalance();

  useEffect(() => {
    const persisted = getPersistedEngineConfigUiState();
    saveEngineConfigPersistence({
      filters: persisted.filters,
      createModalOpen: false,
      formValues: null
    });
  }, []);

  return (
    <DashboardLayout>
      <div className="dashboard-page">
        <DashboardTopbar title={t("Engine Configuration")} tokenBalance={tokenBalance} />
        <div className="page-content">
          <EngineConfigForm configId={id} variant="page" />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default EngineConfig;
